import script from "./TeamMember.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamMember.vue?vue&type=script&lang=ts&setup=true"

import "./TeamMember.vue?vue&type=style&index=0&id=bac6dd7a&lang=scss"

const __exports__ = script;

export default __exports__